import React from 'react';
import { Link } from 'react-router-dom';
import Seo from '../../GlobalComp/Seo/Seo';
import LegalDoc from '../../GlobalComp/LegalDoc/LegalDoc';
import { SITE } from '../../../data/siteConfig';

const email = <a href="mailto:561fixhome@gmail.com">561fixhome@gmail.com</a>;
const phone = <a href={`tel:${SITE.phoneE164}`}>{SITE.phone}</a>;

const sections = [
    {
        title: 'About Us',
        body: [`${SITE.legalName} is a licensed and insured Florida general contractor (license #${SITE.license}) providing remodeling, renovation and general contracting services in Palm Beach and Broward counties.`],
    },
    {
        title: 'Website Information',
        body: ['The content on this website, including service descriptions, photos and reviews, is provided for general information. It is not a quote, contract or guarantee of availability. Photos show examples of completed work and may not represent your specific project.'],
    },
    {
        title: 'Estimates and Quotes',
        list: [
            'Free estimates are offered for renovation projects.',
            'Small repair jobs and emergency calls may have a service call fee to assess the job, which we will tell you about before the visit.',
            'A quote is based on the information and site conditions known at the time. If the scope changes or hidden conditions are found, we will discuss any changes with you before continuing.',
        ],
    },
    {
        title: 'Work Agreements',
        body: ['All work is governed by a separate written estimate, proposal or contract between you and 561-FIX-HOME. That agreement sets out the scope, price, schedule, payment terms, permits and warranty for your project. If it conflicts with these Terms, the written agreement controls.'],
    },
    {
        title: 'Scheduling and Online Booking',
        body: ['Online appointments are booked through Housecall Pro, a third-party scheduling service, and are subject to its terms. An online booking is a request for a visit; we will confirm the time with you. Please let us know as early as possible if you need to reschedule or cancel.'],
    },
    {
        title: 'Contact Forms and Communications',
        body: ['By submitting a form or contacting us, you agree that we may reach you by phone, text or email about your request. Please provide accurate information. Messages that are abusive, spam or unrelated to our services may be ignored.'],
    },
    {
        title: 'Warranty',
        body: ['We stand behind our work. Warranty coverage and its length are described in your written agreement. Manufacturer warranties on materials and products are provided by their manufacturers.'],
    },
    {
        title: 'Website Use',
        list: [
            'Use this website only for lawful purposes.',
            'Do not attempt to interfere with the website, its forms or its security, or submit automated or bulk requests.',
            'The 561-FIX-HOME name, logo, text and photos on this site belong to us and may not be copied for commercial use without permission.',
        ],
    },
    {
        title: 'Third-Party Links',
        body: ['This website links to services we do not control, such as Housecall Pro and Google. We are not responsible for their content, availability or practices.'],
    },
    {
        title: 'Disclaimer and Limitation of Liability',
        body: ['This website is provided “as is.” We work to keep it accurate and available, but we do not guarantee it will always be error-free or uninterrupted. To the fullest extent allowed by law, 561-FIX-HOME is not liable for any loss arising from your use of this website. This does not limit any rights you have under your written work agreement or under Florida law.'],
    },
    {
        title: 'Governing Law',
        body: ['These Terms are governed by the laws of the State of Florida. Any dispute relating to this website will be handled in the courts of Palm Beach County, Florida.'],
    },
    {
        title: 'Changes to These Terms',
        body: ['We may update these Terms from time to time. The latest version will always be posted on this page with its effective date.'],
    },
    {
        title: 'Contact Us',
        body: [
            <>Questions about these Terms? Contact {SITE.legalName}:</>,
            <>{SITE.address.streetAddress}, {SITE.address.addressLocality}, {SITE.address.addressRegion} {SITE.address.postalCode}<br />Phone: {phone}<br />Email: {email}</>,
        ],
    },
];

export default function TermsOfService() {
    return (
        <>
            <Seo title="Terms of Service | 561-FIX-HOME" description="Terms for using the 561-FIX-HOME website, requesting estimates and booking services." path="/terms-of-service" />
            <LegalDoc
                title="Terms of Service"
                effectiveDate="October 5, 2026"
                intro={[
                    <>These Terms of Service apply to your use of <Link to="/">561fixhome.com</Link>, operated by {SITE.legalName} (“561-FIX-HOME,” “we,” “us”). By using this website, requesting an estimate or booking an appointment, you agree to these Terms. Please also read our <Link to="/privacy-policy">Privacy Policy</Link>.</>,
                ]}
                sections={sections}
            />
        </>
    );
}
